import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import CalNextSingle from '../../../../assets/images/icon-next-single.svg';
import CalPrevSingle from '../../../../assets/images/icon-prev-single.svg';
import SearchIcon from '../../../../assets/images/search-solid.svg';
import { Ads14Full } from '../../../components/Ads';
import InitInfo from '../../../utils/InitInfo';
import BoxNews from '../components/BoxNews';

export default function ArchiveSection({ articles, date }) {
  const { categoryAr } = InitInfo();
  const totalCat = articles.length;
  const timeStamp = new Date(date).getTime() / 1000;
  const prevTimeStamp = timeStamp - 3600 * 24;
  const prevTime = new Date(prevTimeStamp * 1000);
  const prevDate = `${prevTime.getFullYear()}-${prevTime.getMonth() + 1}-${prevTime.getDate()}`;

  const nextTimeStamp = timeStamp + 3600 * 24;
  const nextTime = new Date(nextTimeStamp * 1000);
  const nextDate = `${nextTime.getFullYear()}-${nextTime.getMonth() + 1}-${nextTime.getDate()}`;

  return (
    <div className='col col-840'>
      <div className='row'>
        <div className='col-2  mb-4'>
          <div className='archive-back-btn'>
            <Link to={`/archive/${prevDate}`}>
              <img src={CalPrevSingle} alt='Cal Prev Single' /> আগের দিন
            </Link>
          </div>
        </div>
        <div className='col-8 archive-title  mb-4'>
          {totalCat > 0 ? (
            <>
              {`"${date}"`} তারিখ এর আর্কাইভে {totalCat} টি খবর পাওয়া গেছে
            </>
          ) : null}
        </div>
        <div className='col-2 mb-4'>
          <div className='archive-back-btn' style={{ float: 'right' }}>
            <Link to={`/archive/${nextDate}`}>
              পরের দিন <img src={CalNextSingle} alt='Cal Prev Single' />
            </Link>
          </div>
        </div>

        {categoryAr.online?.map((cat) => {
          const archiveDataAr = Object.values(articles).filter((e) => e.page === cat.page_id);

          return (
            <Fragment key={cat.page_id}>
              {archiveDataAr.length > 0 ? (
                <div className='col-12'>
                  <div className='home-category-news-title'>
                    <div className='home-category-news-title-sub'>
                      <Link to='...'>{cat.title}</Link>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
              {archiveDataAr?.map((art) => (
                <div className='col-lg-4 col-xl-4 col-12' key={art.sl}>
                  <BoxNews article={art} />
                </div>
              ))}
            </Fragment>
          );
        })}
        {!articles ? (
          <div className='search-data-n-found'>
            <div className='search-data-n-found-h'>অনুসন্ধানের কোনো ফলাফল পাওয়া যায়নি</div>
            <div className='search-data-n-found-b'>
              আমরা দুঃখিত. আমরা আপনার অনুসন্ধান শব্দটির জন্য কোন মিল খুঁজে পাচ্ছি না।
            </div>
            <div className='search-data-n-found-i'>
              <img src={SearchIcon} style={{ width: 50 }} alt='Search' />
            </div>
          </div>
        ) : (
          ''
        )}
        <div className='col-12'>
          <Ads14Full show mode='placeholder' />
        </div>
      </div>
    </div>
  );
}
